import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { createSelectors } from '../utils/createSelector'

type UIState = {
  isAudioPlayerSmall: boolean
  isLoginModalOpen: boolean
}

type UIActions = {
  setIsAudioPlayerSmall: () => void
  toggleLoginModal: () => void
  resetState: () => void
}

const defaultState: UIState = {
  isAudioPlayerSmall: false,
  isLoginModalOpen: false,
}

export const useUIStore = createSelectors(
  create<UIState & UIActions>()(
    immer((set) => ({
      ...defaultState,

      toggleLoginModal: () =>
        set((state) => {
          state.isLoginModalOpen = !state.isLoginModalOpen
        }),
      setIsAudioPlayerSmall: () =>
        set((state) => {
          state.isAudioPlayerSmall = !state.isAudioPlayerSmall
        }),
      resetState: () => set(defaultState),
    })),
  ),
)
